import { FC, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import moment from 'moment'

import { Sender, LoginStageStore } from './types'

interface MatchParams {
  recipient: string
  senderEmail: string
  senderName: string
  missionCompletedEmail?: string
}

interface Props {
  setSender: (sender: Sender) => void
  getLoginStage: () => LoginStageStore | null
}

const Init: FC<Props> = ({ setSender, getLoginStage }) => {
  const params = useParams<MatchParams>()
  const history = useHistory()
  const { recipient, senderEmail, senderName, missionCompletedEmail } = params

  useEffect(() => {
    // Set the user and sender info in global state
    setSender({
      email: senderEmail,
      name: senderName,
    })

    // Send to signup if a welcome email, send to reset if from no-reply,
    // otherwise send to index route (which will attempt to authenticate
    // or send to login)
    // console.log('----sender email', senderEmail)
    switch (senderEmail) {
      case 'welcome@maverickapp.io':
        history.push(`/signup/${recipient}`)
        break
      case 'no-reply@verificationemail.com': {
        const loginStage = getLoginStage()
        // console.log(loginStage)

        // If the login stage has been set within the last hour, it is valid
        if (
          moment(loginStage?.lastModified)
            .add(1, 'hour')
            .isAfter(moment())
        ) {
          if (loginStage?.loginStage === 'reset') {
            history.push(`/reset-password/${recipient}`)
            break
          } else {
            history.push('/login')
            break
          }
        }

        // If the login stage hasn't been set within the last hour, delete the
        // loginStage key from local storage for cleanup and sent to reset password page
        localStorage.removeItem('loginStage')
        history.push(`/reset-password/${recipient}`)
        break
      }
      case 'maverick@maverickapp.io':
        if (missionCompletedEmail) {
          history.push(`/prospects/${missionCompletedEmail}`)
        } else {
          history.push('/')
        }
        break
      default:
        history.push('/')
    }
  }, [])

  return null
}

export default Init
